/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const RecordToReportSingleBar = ({ data }) => {
  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: 'Trademarks',
        data: data.map((item) => item.value),
        backgroundColor: '#f5db12ff',
        borderRadius: 4,
         barThickness: 50,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false, // ✅ Crucial for full height behavior
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '200px' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default RecordToReportSingleBar;
